const perPageOptions = [
  10,
  15,
  20,
  30,
  50,
  100,
];

const MIN_PAGE_NUMBER = 1;

const getPageSlices = (currentPage, perPage, totalFiltered) => {
  let start = (currentPage - 1) * perPage;
  let end = currentPage * perPage;

  if (start > totalFiltered) {
    start = 0;
    end = perPage;
  }

  return {start, end};
};

export {
  MIN_PAGE_NUMBER,
  getPageSlices,
  perPageOptions,
};
